<!-- 选项卡价格 -->
<template>
  <div class="tabs-mu-ban">
    <el-tabs v-model="activeIndex" tab-position="left" @tab-click="tabToggle">
      <el-tab-pane v-for="(item, index) in navList" :key="index" :label="item.key" :name="item.val">
        <slot />
      </el-tab-pane>
    </el-tabs>
    <router-view />
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeIndex: '',
      navList: []
    }
  },
  mounted() {
    this.activeIndex = this.index
    this.navList = this.list.map((item, index) => {
      return {
        key: item.mu_ban_ming_cheng,
        val: JSON.stringify(index)
      }
    })
  },
  methods: {
    tabToggle() {
      this.$emit('update:index', this.activeIndex)
    }
  }
}
</script>

<style lang="less" scoped>
.tabs-mu-ban {
}
</style>
